import { Avatar, Box, Table, Text } from '@factorialco/deprecated-design-system'
import {
  AssessmentsTableEmployeeFragment,
  AssessmentsTableJobCatalogLevelFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'

import { useRoleCompetencies } from 'modules/job_catalog/hooks/useRoleCompetencies'

interface Props {
  employee: AssessmentsTableEmployeeFragment
  jobLevel?: AssessmentsTableJobCatalogLevelFragment
  jobTitle?: string
}

const UserRow = ({ employee, jobLevel, jobTitle }: Props) => {
  const jobRoleId = jobLevel?.role?.id ?? 0
  const jobRoleName = jobLevel?.role?.name ?? jobTitle
  const [_] = useRoleCompetencies(jobRoleId, true)

  const jobCatalogRoleLevel = () => {
    return jobLevel?.name && jobRoleName ? `${jobRoleName}, ${jobLevel?.name}` : jobRoleName
  }

  return (
    <>
      <Table.Row>
        <Table.Cell colSpan={6}>
          <Box
            flexDirection="row"
            gap="s16"
            alignItems="center"
            aria-label="name-of-assessed-employee"
          >
            <Avatar
              size={'s40'}
              url={buildUrl(employee.access.avatar)}
              label={employee.fullName ?? ''}
            />

            <Text.Normal>{employee.fullName}</Text.Normal>
          </Box>
        </Table.Cell>
        <Table.Cell colSpan={6}>
          <Text.Normal>{jobCatalogRoleLevel()}</Text.Normal>
        </Table.Cell>
      </Table.Row>
    </>
  )
}

export default observer(UserRow)
